/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_File_Size_ErrorInputs */

const en_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File must be under 5 MB`)
};

const de_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei muss unter 5 MB sein`)
};

const fr_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fichier doit faire moins de 5 Mo`)
};

const es_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo debe ser menor a 5 MB`)
};

const it_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il file deve essere inferiore a 5 MB`)
};

const nl_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestand moet kleiner zijn dan 5 MB`)
};

const pl_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plik musi być mniejszy niż 5 MB`)
};

const fi_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedoston on oltava alle 5 Mt`)
};

const da_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filen skal være under 5 MB`)
};

const sv_resumes_file_size_error = /** @type {(inputs: Resumes_File_Size_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filen måste vara under 5 MB`)
};

/**
* | output |
* | --- |
* | "File must be under 5 MB" |
*
* @param {Resumes_File_Size_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_file_size_error = /** @type {((inputs?: Resumes_File_Size_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_File_Size_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_file_size_error(inputs)
	if (locale === "fr") return fr_resumes_file_size_error(inputs)
	if (locale === "es") return es_resumes_file_size_error(inputs)
	if (locale === "it") return it_resumes_file_size_error(inputs)
	if (locale === "nl") return nl_resumes_file_size_error(inputs)
	if (locale === "pl") return pl_resumes_file_size_error(inputs)
	if (locale === "fi") return fi_resumes_file_size_error(inputs)
	if (locale === "da") return da_resumes_file_size_error(inputs)
	if (locale === "sv") return sv_resumes_file_size_error(inputs)
	return en_resumes_file_size_error(inputs)
});